"use client";

import React from "react";
import { Heading, Link, Separator, Text } from "ui-components";

import { SocialLoginButton } from "@/components/homepage/HeroSection";
import { useAuth } from "@/hooks/useAuth";

export function Authentication(): JSX.Element | null {
  const buttonInitials = "Join with";
  const { isAuthenticated } = useAuth();
  if (isAuthenticated) {
    return null;
  }
  return (
    <div
      id="authentication-section"
      className="relative left-1/2 right-1/2 ml-[-50vw] mr-[-50vw] w-[100vw] bg-[#FBE4D8]"
    >
      <div className="mx-auto w-full md:w-[1130px] flex gap-6 md:gap-16 py-10 px-2 md:px-0 md:py-14 md:items-center flex-col md:flex-row">
        <div className="w-full md:w-[525px] flex flex-col justify-start items-start gap-4 md:gap-12 md:mt-4">
          <Heading className="px-2 md:px-0">
            Join the leading global inclusive talent platform.
          </Heading>
          <ul className="list-disc text-lg font-semibold list-outside m-0 pl-5 px-4 mx-3 md:px-5 md:mx-0">
            <li className="pb-2">
              <Text variant="large">
                Reach LGBTQ+ professionals and graduates worldwide through our
                dedicated job board
              </Text>
            </li>
            <li className="pb-2">
              <Text variant="large">
                Discover relevant roles and save jobs to apply later
              </Text>
            </li>
            <li className="pb-2">
              <Text variant="large">
                Build inclusive connections via networking, mentoring, events,
                and community resources
              </Text>
            </li>
            <li className="pb-2">
              <Text variant="large">
                Support allyship and accelerate workplace inclusion across your
                organisation
              </Text>
            </li>
          </ul>
        </div>
        <div className="px-6 py-6 bg-white rounded-3xl inline-flex flex-col justify-start items-center gap-10">
          <div className="flex flex-col gap-y-2.5 lg:gap-y-[15px] w-full text-sm">
            <Text align="center">
              Free to join — save jobs, set up role alerts, and connect with
              inclusive employers.
            </Text>
            <SocialLoginButton
              type="linked-in"
              buttonInitials={buttonInitials}
            />
            <SocialLoginButton type="google" buttonInitials={buttonInitials} />
            <SocialLoginButton type="apple" buttonInitials={buttonInitials} />
            <Text variant="small" align="center">
              We only use your name and email. Your myGwork activity is never
              shared back to LinkedIn, Google, or Apple.
            </Text>
            <Separator text="or" />
            <SocialLoginButton type="email" buttonInitials={buttonInitials} />
            <Text variant="small" align="center" className="-mt-[5px]">
              This site is protected by reCAPTCHA and the Google Privacy Policy
              and Terms of Service apply.
            </Text>
            <Text className="flex justify-center items-center">
              <Text variant="small" className="mr-1">
                Already have an account?
              </Text>
              <Link
                href="/signin"
                intent="secondary"
                fontSize="sm"
                className="!text-black"
              >
                Log in
              </Link>
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
}
